module.exports = __webpack_public_path__ + "img/slide1.1be4b585.png";